import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';

// ShadowGovernor — only render shadow maps when something can RECEIVE a shadow.
//
// The town's key light casts, so three re-renders a 2048² shadow map every
// frame. But nothing in the model city, and nothing in most of the mesh rooms,
// sets receiveShadow (audited 2026-09-23: street, studio, concert hall and
// record store all had casters and ZERO receivers) — a full extra pass of every
// caster, every frame, for a texture no shader ever samples.
//
// shadowMap.ENABLED stays on: flipping it changes what every material compiles
// to and would recompile the whole scene. What changes is AUTO-UPDATE — the
// per-frame pass. Checked about once a second; when a receiver appears (a legacy
// room's floor, the portal's ground) shadows resume on the next frame.
const CHECK_MS = 1000;

export default function ShadowGovernor() {
  const gl = useThree((s) => s.gl);
  const scene = useThree((s) => s.scene);

  useEffect(() => {
    if (!gl.shadowMap.enabled) return undefined;
    let last = null;
    const check = () => {
      let caster = false; let receiver = false;
      scene.traverseVisible((o) => {
        if (o.isLight && o.castShadow) caster = true;
        else if (o.isMesh && o.receiveShadow) receiver = true;
      });
      const on = caster && receiver;
      if (on !== last) {
        gl.shadowMap.autoUpdate = on;
        gl.shadowMap.needsUpdate = on;
        last = on;
      }
    };
    check();
    const id = setInterval(check, CHECK_MS);
    return () => { clearInterval(id); gl.shadowMap.autoUpdate = true; };
  }, [gl, scene]);

  return null;
}
